import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../utils/Card/Card';
import Button from '../../utils/Button/button';
import Badge from '../../utils/Badge/Badge';
import { useDispatch, useSelector } from "react-redux";
import { ArrowUpRight, ArrowDownLeft, Eye, ChevronRight, ArrowLeft, DollarSign, TrendingUp, Activity, CreditCard, Wallet, Bot, BarChart3, Clock, Search, Filter, X, Plus, ChevronDown, CalendarDays, ArrowUpDown } from 'lucide-react'
import { motion } from 'motion/react';
import './Prepaid.scss'; // 👈 SCSS import
import actions from '../../redux/indicore/actions';


export default function Prepaid({ onViewChange }) {
  // calculate summary

  const [newAgentInformation, setNewAgentInformation] = useState(null);
  const dispatch = useDispatch();

  const { loading, agentInformation } = useSelector(
    (state) => state.authReducer
  );

  const profileData = useSelector(state => state.authReducer.profileData);

  const { allTransactions = [], summary } =
    useSelector((state) => state?.indicoreReducer || {});


  console.log("summary in prepaid", summary);

  useEffect(() => {
    if (agentInformation?.data) {
      setNewAgentInformation(agentInformation);
    }
  }, [agentInformation?.data]);


  useEffect(() => {
    if(profileData?.orgId){
    dispatch(actions.getSuccessSummary(profileData.orgId));
    }
  }, [dispatch, profileData?.orgId]);


  return (
    <motion.div className="prepaid-dashboard">
      {/* Header */}
      <div className="dashboard-header">
        <div className="header-left">
          <BarChart3 className="icon " />
          <h1>Prepaid Recharge</h1>
        </div>
        <div className="header-right">
          <Clock className="icon small" />
          Last updated: {new Date().toLocaleString()}
        </div>
      </div>

      {/* Metrics */}
      <div className="metrics-grid">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
          whileHover={{ y: -5, scale: 1.02 }}
        >
          <Card variant="gradient-green">
            <div className="card-decor"></div>
            <CardHeader>
              <CardTitle>Current Balance</CardTitle>
              <Wallet className="icon" />
            </CardHeader>
            <CardContent>
              <div className="card-value">₹{newAgentInformation?.data?.balance.plutosBalance}</div>
              <div className="card-trend">
                {/* <TrendingUp className="icon-small" /> */}
                {/* <p className="subtext">+12.5% from last month</p> */}
              </div>
            </CardContent>
          </Card>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          whileHover={{ y: -5, scale: 1.02 }}
        >
          <Card variant="gradient-blue">
            <div className="card-decor"></div>
            <CardHeader>
              <CardTitle>AI Commission</CardTitle>
              <Bot className="icon" />
            </CardHeader>
            <CardContent>
              {/* <div className="card-value">₹300</div> */}
              <div className="card-value">₹{summary?.aiCommission ?? 0}
              <div className="card-trend"></div>
                {/* <TrendingUp className="icon" /> */}
                {/* <p>+8.2% from last month</p> */}
              </div>
            </CardContent>
          </Card>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          whileHover={{ y: -5, scale: 1.02 }}
        >
          <Card variant="gradient-orange">
            <div className="card-decor"></div>
            <CardHeader>
              <CardTitle>Total Transactions</CardTitle>
              <Activity className="icon" />
            </CardHeader>
            <CardContent>
              <div className="card-value">{summary?.totalTransactions ?? 0}</div>
              <div className="card-trend">
                {/* <TrendingUp className="icon" /> */}
                {/* <p>+3 from yesterday</p> */}
              </div>
            </CardContent>
          </Card>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
          whileHover={{ y: -5, scale: 1.02 }}
        >
          <Card variant="gradient-purple">
            <div className="card-decor"></div>
            <CardHeader>
              <CardTitle>Total Amount</CardTitle>
              <DollarSign className="icon" />
            </CardHeader>
            <CardContent>
              <div className="card-value">₹{summary?.totalAmount ?? 0}</div>
              <div className="card-trend">
                {/* <TrendingUp className="icon" /> */}
                {/* <p>+15.3% from last month</p> */}
              </div>
            </CardContent>
          </Card>
        </motion.div>

      </div>

      {/* Latest Transactions */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.7 }}
      >
        <Card className="card-latest">
          <div className="card-latest-header">
            <CardTitle className="card-latest-title">
              <Activity className="icon-white" />
              Latest Transactions
            </CardTitle>
            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
              <Button
                onClick={() => onViewChange("all-transactions")}
                className="btn-glass"
              >
                <Eye /> View All
              </Button>
            </motion.div>
          </div>

          <CardContent className="p-6">
            <div className="transactions-list">
              {allTransactions?.data?.slice(0, 8).map((transaction, index) => (
                <motion.div
                  key={transaction.id}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.8 + (index * 0.05) }}
                  whileHover={{ scale: 1.01, y: -2 }}
                  className="transaction-item"
                  onClick={() => onViewChange('transaction-detail', transaction)}
                >
                  {/* Left */}
                  <div className="transaction-left">
                    <motion.div
                      whileHover={{ rotate: 360 }}
                      transition={{ duration: 0.3 }}
                      className={`transaction-icon ${transaction?.response?.status === 'Success' ? 'Success' : 'failure'}`}
                    >
                      {transaction?.response?.status === 'Success' ?
                        <ArrowUpRight /> :
                        <ArrowDownLeft />
                      }
                    </motion.div>
                    <div className="transaction-info">
                      <p className="transaction-desc">{transaction.request.operator}</p>
                      <p className="transaction-meta">
                        {new Date(transaction.createdAt).toLocaleString('en-IN', {
                          year: 'numeric',
                          month: 'short',
                          day: '2-digit',
                          hour: '2-digit',
                          minute: '2-digit',
                        })}
                      </p>

                      <p style={{ fontSize: "12px", color: "gray" }}>
                        Refid: {transaction.refId}
                      </p>
                    </div>
                  </div>

                  {/* Right */}
                  <div className="transaction-right">
                    <div className="transaction-amount">
                      <p className={`value ${transaction?.response?.status === 'Success' ? 'Success' : 'failure'}`}>
                        {transaction?.response?.status === 'Success' ? '+' : '-'}₹{transaction.request.amount}
                      </p>
                      {
                        transaction?.response?.status === 'Success' ? <p className="commission">
                          {/* Commission: $300 */}
                        </p> : ""
                      }


                    </div>
                    <Badge
                      className={`transaction-badge ${transaction?.response?.status === 'Success' ? 'Success' : 'failure'}`}
                    >
                      {transaction?.response?.status ? transaction?.response?.status : "no status"}
                    </Badge>
                    {/* <motion.div
                      whileHover={{ x: 5 }}
                      transition={{ duration: 0.2 }}
                      className="transaction-chevron"
                    >
                      <ChevronRight />
                    </motion.div> */}
                  </div>
                </motion.div>
              ))}
            </div>
          </CardContent>

        </Card>
      </motion.div>

    </motion.div>
  );
}
